'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductListDirective = undefined;

var _tpl = require('./tpl.html');

var _tpl2 = _interopRequireDefault(_tpl);

var _index = require('./index');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductListDirective = function ProductListDirective() {
  return {
    restrict: 'E',
    template: _tpl2.default,
    controller: _index.ProductListController,
    controllerAs: '$ctrl',
    scope: {},
    bindToController: {
      feis: '=',
      viewStyle: '=?',
      editable: '=?',
      purchaseProduct: '&'
    }
  };
};

exports.ProductListDirective = ProductListDirective;


//////////////////
// WEBPACK FOOTER
// ./product-list/product-list.directive.js
// module id = 500
// module chunks = 0